export default class Text {
	static NAME = "text";

	get_name() {
		return Text.NAME;
	}

	get_enclosing_rectangle() {
	}

	get_area() {
	}

	get_circumference() {
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			width: maximum_rectangle.get_length(),
			height: maximum_rectangle.get_width()
		};
	}

	get_dimension_keys() {
		return ["desired_length"];
	}

	get_modifier_keys() {
		return ["font", "text", "desired_dimension"];
	}

	serialize_primitives() {
	}

	static deserialize_primitives() {
	}
}
